export default __webpack_public_path__ + "static/media/fsk-24-b.e77d1aa6.jpg";